import React from "react";
import IconBase from "./IconBase";
import icon from "./menu.svg";

export default function IconMenu({ width, height }) {
  return <IconBase alt={"Menue"} img={icon} width={width} height={height} />;
}
